import { useHoverIntent } from '@hooks/useHoverIntent';
import { ReactComponent as SvgArrow } from '@img/icons/nav-arrow-down.svg';
import * as React from 'react';
import S from './NavigationDesktop.styles';
import NavigationMegaMenu from './NavigationMegaMenu/NavigationMegaMenu';
import NavigationSimpleMenu from './NavigationSimpleMenu/NavigationSimpleMenu';
const Item = (props) => {
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            props.onActivateChange(true);
        },
    });
    const hasChildren = !!props.item.children?.length || !!props.item.featured?.length;
    return (React.createElement(S.Item, { key: props.item.id, ref: anchorRef, "data-active": props.active, "data-type": props.item.type },
        React.createElement(S.Link, { href: props.item.url, target: props.item.target, ...(hasChildren
                ? {
                    onKeyDown: (event) => {
                        switch (event.key) {
                            case 'ArrowDown':
                                event.preventDefault();
                                props.onActivateChange(true);
                                break;
                            case 'Escape':
                            case 'ArrowUp':
                                event.preventDefault();
                                props.onActivateChange(false);
                                break;
                            default:
                                break;
                        }
                    },
                }
                : {
                    onFocus: () => props.onActivateChange(true),
                    onBlur: () => props.onActivateChange(false),
                }) },
            props.item.text,
            hasChildren && React.createElement(S.Icon, { as: SvgArrow })),
        hasChildren && renderSubNavigation()));
    function renderSubNavigation() {
        if (!props.item.children?.length && !props.item.featured?.length) {
            return null;
        }
        switch (props.item.type) {
            case 'mega':
                return (React.createElement(NavigationMegaMenu, { active: props.active, items: props.item.children ?? [], featured: props.item.featured }));
            case 'simple':
                return (React.createElement(NavigationSimpleMenu, { active: props.active, items: props.item.children ?? [], onActivateChange: props.onActivateChange }));
            default:
                return null;
        }
    }
};
const NavigationDesktop = (props) => {
    const [activeItem, setActiveItem] = React.useState();
    return (React.createElement(S.Container, { onMouseLeave: () => setActiveItem(undefined) },
        React.createElement(S.List, null, props.items.map((item) => (React.createElement(Item, { key: item.id, active: activeItem?.id === item.id, item: item, onActivateChange: (active) => {
                if (active) {
                    setActiveItem(item);
                }
                else {
                    setActiveItem(undefined);
                }
            } }))))));
};
export default NavigationDesktop;
